import { render } from "./Tabs.vue?vue&type=template&id=663bac2f&scoped=true"
import script from "./Tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=663bac2f&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663bac2f"],['__file',"src/components/tabs/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "663bac2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('663bac2f', __exports__)) {
    console.log('reload')
    api.reload('663bac2f', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=663bac2f&scoped=true", () => {
    console.log('re-render')
    api.rerender('663bac2f', render)
  })

}


export default __exports__